import {Company} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';
import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {LookupCompaniesParams} from '../../endpoints/companies';

export const lookupCompanies = async (
  params: LookupCompaniesParams,
): Promise<Company[]> => {
  return await tinctApi.companies.lookupCompanies(params);
};

export const useLookupCompanies = (
  params: LookupCompaniesParams,
  options?: Omit<
    UseQueryOptions<Company[], ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['companies', 'lookup', params],
    queryFn: () => lookupCompanies(params),
    ...options,
  });
